var _style, _polygon, _g, _path, _polygon2, _polygon3, _polygon4, _polygon5, _path2, _polygon6, _polygon7, _polygon8, _path3, _polygon9, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLg3DCmyk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792 612",
    style: {
      enableBackground: "new 0 0 792 612"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#6D6E71;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:url(#SVGID_00000150818286433861837140000017224396313055936414_);}\n\t.st3{fill:url(#SVGID_00000113313986717824921910000015146247094627770274_);}\n\t.st4{fill:#616D76;}\n\t.st5{fill:#879AA4;}\n\t.st6{fill:#8E9BA1;}\n\t.st7{fill:url(#SVGID_00000016796600682644845400000013021515065321333916_);}\n\t.st8{fill:url(#SVGID_00000116935537587208631850000014270876640829811334_);}\n\t.st9{fill:#B5BEC4;}\n\t.st10{fill:none;}\n\t.st11{fill:url(#SVGID_00000035504052840932955990000006710357811934340270_);}\n\t.st12{fill:#505C61;}\n\t.st13{fill:#0B2028;}\n\t.st14{fill:#8F9DA5;}\n\t.st15{fill:url(#SVGID_00000049909193831635752070000016898086324478567329_);}\n\t.st16{fill:url(#SVGID_00000029766895923519935450000006799331860872055738_);}\n\t.st17{fill:url(#SVGID_00000012471561836303687510000004613483999421875122_);}\n\t.st18{fill:url(#SVGID_00000134213312595948097380000001197606701587206832_);}\n\t.st19{fill:url(#SVGID_00000021821311198291143850000005763928917384043145_);}\n\t.st20{fill:url(#SVGID_00000045584794617065884660000011588226224095524795_);}\n\t.st21{fill:#FFFFFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "432.62,198.97 395.29,198.97 395.29,360.56 509.96,360.56 509.96,329.09 432.62,329.09 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M592.09,298.97h30.39v28.25c-5.6,2.14-16.52,4.28-26.92,4.28c-33.61,0-44.81-17.08-44.81-51.74 c0-33.06,10.66-52.53,44.26-52.53c18.68,0,29.33,5.87,38.13,17.07l23.21-21.33c-14.15-20.26-38.94-26.39-62.14-26.39 c-52.26,0-79.73,28.53-79.73,82.92c0,54.14,24.8,83.47,79.46,83.47c25.07,0,49.6-6.4,62.93-15.73v-78.4h-64.79V298.97z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -22.1314,
    cy: 621.3336,
    r: 4.0803,
    gradientTransform: "matrix(31.9334 0 0 -31.9334 916.522 20117.9258)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C00C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#C00C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    style: {
      stopColor: "#BF0C3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8358,
    style: {
      stopColor: "#B90A3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9094,
    style: {
      stopColor: "#B00737"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9701,
    style: {
      stopColor: "#A30330"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9A002B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.35,155.47c-68.94,0-124.91,55.94-124.91,124.98c0,69.04,55.97,124.98,124.91,124.98 c68.79,0,124.54-55.41,125.07-124.01v-1.95C338.89,210.88,283.14,155.47,214.35,155.47z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047056225058092695550000015178313291118398628_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.2355,
    y1: 171.6157,
    x2: 229.1762,
    y2: 352.7861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F48996"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    style: {
      stopColor: "#F28693"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    style: {
      stopColor: "#DB5A69"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4875,
    style: {
      stopColor: "#CC3750"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6746,
    style: {
      stopColor: "#C31B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8011,
    style: {
      stopColor: "#C00C3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C00C3F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047056225058092695550000015178313291118398628_)"
    },
    d: "M129.8,195.85 c-41.76,41.77-45.99,105.42-9.32,142.1c36.67,36.66,100.27,32.46,142.05-9.34c41.84-41.86,46.06-105.49,9.41-142.17 c-16.74-16.75-39.1-24.98-62.47-24.98C181.7,161.47,152.52,173.12,129.8,195.85"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015349794764547268780000010029636952032725406_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.022,
    y1: 216.3917,
    x2: 282.2697,
    y2: 367.6394
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CE425C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0902,
    style: {
      stopColor: "#BD3551"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2501,
    style: {
      stopColor: "#A82242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.431,
    style: {
      stopColor: "#9B1438"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#930933"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#910531"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015349794764547268780000010029636952032725406_)"
    },
    d: "M207.95,336.46l3.09-1.76l-0.01-105.59 l-0.77-1.23l0.77-0.23v-0.16h0.54l9.34-3.2l1.68,2.89c0,0,0.25,0.25,0.23,0.8l-0.09,96.15h22.72l1.82,2.85 c0.17,0.21,0.28,0.45,0.28,1.17v9.67c0,0.54-0.32,0.77-0.7,0.83h-34.76c-0.83,0.03-1.55-0.37-1.74-0.51L207.95,336.46z  M320.71,274.7l-77.31,0.03v12.38l1.92,2.57l0,0c0,0,0.23,0.25,0.66,0.25h58.93h5.68h0.02h0.07c-3.34,48.92-44.6,87.21-93.9,87.21 c-25.12,0-48.74-9.76-66.55-27.41c-17.74-17.67-27.5-41.13-27.5-66.12c0-25,9.25-48.97,26.99-66.61 c17.85-17.61,40.31-26.91,67.2-27.49l5.08-0.08h0.57c0.35-0.04,0.66-0.05,0.66-0.83v-10.14c0-0.74-0.25-1.09-0.25-1.1l-2.28-2.86 l-5.15,0.74l-2.6,0.86c-58.71,0-102.73,49.07-102.73,107.51c0,28.27,11.11,54.89,31.22,74.9c20.09,20.02,46.73,30.15,75.16,30.15 c28.56,0,55.38-10.77,75.46-30.79c20.14-20.01,31.22-46.62,31.22-74.89v-6.1L320.71,274.7z M176.08,225.76 c-9.29,0-16.81,7.49-16.81,16.7c0,9.2,7.52,16.66,16.81,16.66c9.28,0,16.8-7.46,16.8-16.66 C192.88,233.25,185.36,225.76,176.08,225.76z"
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "210.49,334.03 207.95,336.46 245.44,336.46 243,333.96  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "243,326.5 245.44,324.12 220.9,324.12 218,326.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "220.9,224.29 207.95,224.29 210.38,226.61 218.13,226.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011721362820980176770000007278778381357854346_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.127,
    y1: 275.2998,
    x2: 220.9014,
    y2: 275.2998
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1753,
    style: {
      stopColor: "#99A2A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    style: {
      stopColor: "#646C74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8544,
    style: {
      stopColor: "#424950"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333940"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000011721362820980176770000007278778381357854346_)"
    },
    points: "218.2,326.31 220.9,324.12  220.9,224.29 218.13,226.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062906142611487191270000007657875038499917224_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.9961,
    y1: 330.291,
    x2: 245.438,
    y2: 330.291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4BCC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1351,
    style: {
      stopColor: "#989FA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#585D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8473,
    style: {
      stopColor: "#373E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3337"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062906142611487191270000007657875038499917224_)"
    },
    points: "243,326.5 243,333.96  245.44,336.46 245.44,324.12  "
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "207.95,224.29 207.95,336.46 210.49,334.03 210.38,226.61  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M160.59,240.54c0,7.63,6.24,13.81,13.91,13.81c7.64,0,13.88-6.18,13.88-13.81c0-7.66-6.24-13.86-13.88-13.86 C166.83,226.69,160.59,232.89,160.59,240.54z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031177107227620155540000002851814426742594697_",
    gradientUnits: "userSpaceOnUse",
    x1: -33.7471,
    y1: 633.4816,
    x2: -30.9028,
    y2: 633.4816,
    gradientTransform: "matrix(8.1027 8.1027 8.1027 -8.1027 -4696.5391 5635.3174)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABBAC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#202428"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031177107227620155540000002851814426742594697_)"
    },
    d: "M158.18,240.54 c0,8.98,7.31,16.26,16.32,16.26c9.02,0,16.31-7.28,16.31-16.26c0-8.99-7.29-16.3-16.31-16.3 C165.49,224.24,158.18,231.55,158.18,240.54z M188.38,240.54c0,7.63-6.24,13.81-13.88,13.81c-7.67,0-13.91-6.18-13.91-13.81 c0-7.66,6.24-13.86,13.91-13.86C182.14,226.69,188.38,232.89,188.38,240.54z"
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "310.15,284.27 245.36,284.19 242.96,286.72 307.66,286.72 308.95,285.38  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "220.67,186.99 220.67,186.99 220.67,186.99  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "245.36,276.88 317.82,276.77 320.27,274.3 242.96,274.32  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063632386730862014040000000044338043041469593_",
    gradientUnits: "userSpaceOnUse",
    x1: -25.7804,
    y1: 612.2635,
    x2: -22.9365,
    y2: 612.2635,
    gradientTransform: "matrix(53.1048 53.1048 53.1048 -53.1048 -31015.1953 34097.9023)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3E454D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063632386730862014040000000044338043041469593_)"
    },
    d: "M320.27,280.41v-6.12l-2.45,2.47v3.65 c0,27.64-10.74,53.62-30.27,73.18c-19.51,19.56-45.54,30.33-73.25,30.33c-27.59,0-53.57-10.77-73.09-30.33 c-19.54-19.58-30.3-45.56-30.3-73.18c0-57.09,46.38-103.5,103.38-103.5l3.95-0.05l2.42-2.35l-6.37-0.06 c-58.33,0-105.83,47.53-105.83,105.96c0,28.27,11.02,54.89,31.01,74.9c19.97,20,46.55,31.05,74.81,31.05 c28.36,0,55-11.04,74.96-31.05C309.28,335.3,320.27,308.69,320.27,280.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031889998864575122840000002879165335262126253_",
    gradientUnits: "userSpaceOnUse",
    x1: -27.2213,
    y1: 604.799,
    x2: -24.3773,
    y2: 604.799,
    gradientTransform: "matrix(-67.4051 0 0 67.4051 -1524.6844 -40486.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B5BEC4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#485059"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031889998864575122840000002879165335262126253_)"
    },
    d: "M218.25,184.55l-2.73-0.06h-2.57 c-25.04,0.36-48.56,10.31-66.44,28.07c-18.07,18.11-28.03,42.21-28.03,67.86c0,25.64,9.96,49.71,28.03,67.83 c17.89,17.84,41.5,27.82,66.62,28.12h2.47c49.74-0.63,91.13-39.71,94.49-89.46l0.09-2.65l-1.22,1.12l-1.29,1.34 c-3.32,48.92-44.31,87.21-93.29,87.21c-24.96,0-48.43-9.76-66.12-27.42c-17.63-17.66-27.32-41.13-27.32-66.11 c0-25,9.69-48.5,27.32-66.14c17.73-17.61,41.19-27.34,66.12-27.34l6.3,0.06L218.25,184.55z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M220.67,186.98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078004679628613714130000002529034733922294449_",
    gradientUnits: "userSpaceOnUse",
    x1: -25.8935,
    y1: 603.4126,
    x2: -25.8935,
    y2: 603.4126,
    gradientTransform: "matrix(-67.4051 0 0 67.4051 -1524.6844 -40486.1055)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A9B8C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0B2028"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078004679628613714130000002529034733922294449_)"
    },
    d: "M220.67,186.98"
  }), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "245.36,276.88 242.96,274.32 242.96,286.72 245.36,284.19  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054972498420737513980000010653582163615507358_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.2534,
    y1: 180.7525,
    x2: 220.6724,
    y2: 180.7525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B4BCC2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1351,
    style: {
      stopColor: "#989FA4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    style: {
      stopColor: "#585D61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8473,
    style: {
      stopColor: "#373E41"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B3337"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000054972498420737513980000010653582163615507358_)"
    },
    points: "218.25,184.57 220.67,186.99  220.67,174.51 218.25,176.86  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000160883544416476386380000003173460489682001343_",
    cx: 89.5789,
    cy: -326.2377,
    r: 229.4647,
    gradientTransform: "matrix(0.6971 0 0 0.6971 109.7092 463.5307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5295,
    style: {
      stopColor: "#F6F8F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7147,
    style: {
      stopColor: "#E6EBEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902,
    style: {
      stopColor: "#CFD9DE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0CCD3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160883544416476386380000003173460489682001343_)"
    },
    d: "M209.32,225.61v109.53h34.83v-9.76H219.3 v-99.77H209.32z M212.97,175.78c-56.96,0.68-103.23,47.35-103.23,104.63c0,27.96,10.89,54.2,30.63,73.96 c19.72,19.77,46.04,30.65,73.88,30.65c28.02,0,54.31-10.88,74.04-30.65c19.76-19.77,30.61-46.01,30.61-73.96v-4.76l-4.13,0.02 h-70.52v9.71h64.72c-0.01,0.23-0.01,1.23-0.03,1.42c-3.36,49.3-44.46,88.46-94.62,88.46c-25.29,0-49.09-9.88-67.06-27.8 c-17.86-17.89-27.72-41.7-27.72-67.05c0-25.37,9.87-49.2,27.72-67.07c17.97-17.86,41.77-27.74,67.06-27.74c1.09,0,3.8,0,5,0.03 v-9.8c-0.99,0-2.62-0.03-3.91-0.05H212.97z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000011722035164753037830000009063307178513432508_",
    cx: 83.9326,
    cy: -327.8127,
    r: 33.5063,
    gradientTransform: "matrix(0.6971 0 0 0.6971 109.7092 463.5307)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5653,
    style: {
      stopColor: "#F6F8F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7879,
    style: {
      stopColor: "#E6EBEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D0DADF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011722035164753037830000009063307178513432508_)"
    },
    d: "M159.41,240.54 c0,8.26,6.77,14.94,15.02,14.94c8.25,0,15-6.68,15-14.94c0-8.33-6.75-15-15-15C166.18,225.55,159.41,232.22,159.41,240.54"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M177.13,228.24c3.44,0,6.58,1.23,9.11,3.19c-2.73-3.56-7.01-5.88-11.8-5.88c-8.27,0-15.03,6.67-15.03,15 c0,4.78,2.32,8.99,5.83,11.72c-1.93-2.51-3.14-5.6-3.14-9.03C162.1,234.94,168.86,228.24,177.13,228.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.3,175.84c-1.31-0.02-3.79-0.07-5.05-0.07c-57.57,0-104.5,46.96-104.5,104.65 c0,27.98,10.89,54.2,30.61,73.97c0.63,0.63,1.29,1.23,1.93,1.85c-18.62-19.56-28.88-45.01-28.88-72.16 C113.4,226.52,154.16,178.73,219.3,175.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.3,325.38c0,0,7.18,2.08,24.83,2.08v-2.08H219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M219.3,228.69v-3.09h-9.97v109.54c0,0,3.12-16.66,3.12-106.45H219.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M318.88,275.65l-74.65,0.02v9.71h2.71v-7.01C311.99,278.37,318.88,275.65,318.88,275.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M308.96,285.38c-0.02,0.21-0.02,1.26-0.06,1.45c-3.32,49.27-44.44,88.44-94.6,88.44 c-25.29,0-49.1-9.88-67.06-27.81c-11.7-11.69-19.95-25.94-24.25-41.47c11.22,40.84,48.57,70.42,92.95,70.42 c47.64,0,91.53-37.31,94.26-91.02H308.96z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLg3DCmyk);
export default __webpack_public_path__ + "static/media/LG_3D_CMYK.ca206e743ac1c96a35e8db514f10da1e.svg";
export { ForwardRef as ReactComponent };